let locales = {
    configStatusLeadsEdit_create: 'Creación de actualizacion de estados Leads',
    configStatusLeadsEdit_update: 'Actualizacion de estados leads',
    configStatusLeadsEdit_name: 'Estado',
    configStatusLeadsEdit_description: 'Descripción',
};
export default locales;